import { render, staticRenderFns } from "./UnderscoreSelect.vue?vue&type=template&id=6f0a48ac&scoped=true&"
import script from "./UnderscoreSelect.vue?vue&type=script&lang=js&"
export * from "./UnderscoreSelect.vue?vue&type=script&lang=js&"
import style0 from "./UnderscoreSelect.vue?vue&type=style&index=0&id=6f0a48ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a48ac",
  null
  
)

export default component.exports